import React from "react";
import { Redirect, useHistory } from "react-router-dom";

import { useAuthContextV2 } from "../../../../../auth-state";
import { useServiceAccountsListPage } from "../../../../../hooks/service-account/service-accounts-list";
import { ServiceAccountsListController } from "../../../../organisms/service-account/service-accounts-list-controller";
import {
  ServiceAccountsListTable,
  ServiceAccountWithDetailPageLink,
} from "../../../../organisms/service-account/service-accounts-list-table";
import { SettingsTemplate } from "../../../../template/settings/default-template";
import { SettingR } from "../../route";
import { Loader } from "../../../../organisms/common/loading";
import { InformationBanner } from "@graffer-inc/console-design-kit";

export const ServiceAccountsListPage: React.FC = () => {
  const { auth } = useAuthContextV2();

  if (!auth.hasPermissions("service_account.service_account.read")) {
    return <Redirect to={SettingR.MyAccount.link({})} />;
  }

  return (
    <SettingsTemplate breadcrumbs={[{ to: "#", title: "サービスアカウント" }]}>
      <h1 className="title">サービスアカウント一覧</h1>
      {auth.data?.orgId && <Content tenantId={auth.data.orgId} />}
    </SettingsTemplate>
  );
};

const Content: React.FC<{
  tenantId: string;
}> = ({ tenantId }) => {
  const { serviceAccounts, isLoading } = useServiceAccountsListPage(tenantId);

  const serviceAccountsWithDetailLink = React.useMemo(
    () =>
      serviceAccounts.map((serviceAccount) => {
        const detailPageLink = SettingR.ServiceAccountDetail.link({
          id: serviceAccount.id,
        });

        return {
          ...serviceAccount,
          detailPageLink,
        };
      }) as ServiceAccountWithDetailPageLink[],
    [serviceAccounts],
  );

  const history = useHistory();

  const handleClickCreate = React.useCallback(() => {
    history.push(SettingR.ServiceAccountCreate.link({}));
  }, [history]);

  return (
    <div className="columns is-centered">
      <div className="column">
        <ServiceAccountsListController onClickCreate={handleClickCreate} />
        <Loader isLoading={isLoading}>
          <ServiceAccountsListTable
            serviceAccounts={serviceAccountsWithDetailLink}
          />
        </Loader>
        {!isLoading && serviceAccountsWithDetailLink.length === 0 && (
          <div className="py-2">
            <InformationBanner
              message="サービスアカウントがまだ登録されていません。"
              description="「新規登録」より、サービスアカウントを登録してください。"
            />
          </div>
        )}
      </div>
    </div>
  );
};
